module.exports = __webpack_public_path__ + "img/P150T_weapon_36.59c05f6a.png";